import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import BlockPlaceholder from 'components/consumer/BlockPlaceholder';
import JBImage from 'components/essentials/JBImage';
import useScreen from 'hooks/useScreen';

const InspirationPhotoCard = ({
  hits,
  hoveredValue,
  index,
  onHoverHandler,
  photo,
  toggleModalView,
}) => {
  const { isMobileOrTablet } = useScreen();
  const [imageLoaded, setImageLoaded] = useState(false);

  const setImageIsLoaded = useCallback(() => {
    setImageLoaded(true);
  }, []);

  if (!photo) {
    return (
      <div className="w-full min-h-[20vh] text-base text-[#5c5c5c] flex items-center justify-center">
        No product found!
      </div>
    );
  }

  const imgHeight = isMobileOrTablet ? 350 : 260;

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <button
      type="button"
      className="flex relative cursor-pointer flex-col items-center justify-center md:mb-[.3rem] min-[1440px]:mb-4 max-[1440px]:w-[33%] max-[1023px]:w-[49.7%] !w-full h-full border-0 !mb-0"
      onMouseOver={() => onHoverHandler(photo.photo_id)}
      onMouseOut={() => onHoverHandler('out')}
      onClick={() => toggleModalView(photo, hits, index)}
    >
      <div
        className={classNames(
          'w-full h-full relative',
          'before:[content:""] before:block before:pt-[100%]',
          '[&_img]:h-full [&_img]:left-0 [&_img]:absolute [&_img]:top-0 [&_img]:w-full [&_img]:[-webkit-user-select:none] [&_img]:[-webkit-touch-callout:none]'
        )}
      >
        {!imageLoaded ? (
          <BlockPlaceholder
            className="!w-full"
            style={{
              height: imgHeight,
            }}
          />
        ) : null}
        <JBImage
          height={imgHeight}
          width={300}
          alt={photo.photo_id}
          src={photo.image_link.replace(
            'pstatic.joybird.com',
            'inspire.imgix.net'
          )}
          trim="auto"
          className={classNames(
            'align-middle object-cover w-full [transition:opacity_.3s_ease-in-out]',
            {
              'opacity-10': !imageLoaded,
              'opacity-100': imageLoaded,
            }
          )}
          onLoad={setImageIsLoaded}
        />
      </div>
      {hoveredValue.hoveredOver === photo.photo_id && imageLoaded ? (
        <div
          className={classNames(
            'text-white [transition:opacity_ease-in] absolute top-0 left-0 bg-[rgba(0,0,0,.5)] w-full min-h-full flex items-center justify-center pointer-events-none z-10 max-[1440px]:w-full max-[1023px]:w-full max-[564px]:hidden',
            {
              hide: !hoveredValue.isHovered,
              'opacity-100': hoveredValue.isHovered,
            }
          )}
        >
          <div className="relative h-[255px] flex items-center flex-col justify-center">
            <div className="text-[.8rem] font-bold mx-auto my-2 w-full">
              {photo.customer_first_name || photo.customer_last_name
                ? `${photo.customer_first_name ||
                    ''} ${photo.customer_last_name.charAt(0) || ''}`
                : `Joybird customer`}
            </div>
          </div>
        </div>
      ) : null}
    </button>
  );
};

InspirationPhotoCard.propTypes = {
  hits: PropTypes.array,
  hoveredValue: PropTypes.shape({
    hoveredOver: PropTypes.string,
    isHovered: PropTypes.bool,
  }),
  index: PropTypes.number,
  onHoverHandler: PropTypes.func,
  photo: PropTypes.shape({
    customer_first_name: PropTypes.string,
    customer_last_name: PropTypes.string,
    image_link: PropTypes.string,
    photo_comment: PropTypes.string,
    photo_id: PropTypes.string,
    products: PropTypes.array,
  }),
  toggleModalView: PropTypes.func,
};

export default InspirationPhotoCard;
